import Helper from './Helper';

class Accesibility {

  constructor(){
    let body = document.querySelector('body');
    body.addEventListener('keyup', this.checkTabPress);
  }

  checkTabPress(e) {
    e.preventDefault();
    if (e.keyCode == 13) {
      if(document.activeElement.classList.contains('js-nav-dropdown-toggler')){
        document.querySelector('#js-dropdown-nav .menu__item--level-1:first-child > a').focus();
      }
    }
    if (e.keyCode == 9) {
        console.log(document.activeElement);
    }
  }
} export default Accesibility;

